module.exports = __webpack_public_path__ + "img/9788983925565.429b08bf.jpg";